import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { handleIEDetection } from './helpers/misc-javascript-helpers.js';
import FeedbackItemsCarousel from './components/FeedbackItemsCarousel/FeedbackItemsCarousel.js';
import { getTestimonialsData } from './utils/api.js';


if (handleIEDetection() === false || handleIEDetection() > 11) { // if not an IE browser then load carousel.
    ReactDOM.render(
        <FeedbackItemsCarousel
            blockTitle={'Testimonials'}
            blockTitleClass={'ubuntu--light h2'}
            data={getTestimonialsData}
        />,
        document.getElementById('feedbackItemsCarousel')
    );
}